import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { ExternalLink } from '@factorialco/f0-react/icons/app'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { termsAndConditionsUrl } from 'modules/referral_program/components/helpers'

const FooterConditions = ({ isMobile }: { isMobile: boolean }) => {
  const { company, employee } = useCurrentSession()

  const mainLegalEntity = company.legalEntities.find((e) => e.main)
  const isoCountryCode = mainLegalEntity?.country || employee?.legalEntity?.country

  if (!isoCountryCode) {
    return null
  }

  const handleTermsAndConditions = () => {
    window.open(termsAndConditionsUrl(isoCountryCode), '_blank')
  }

  return (
    <Box
      gap="s24"
      style={{
        flex: '2',
      }}
    >
      <Box gap="s8" flexDirection="column">
        <Text weight="semibold" size={'500'} color="black">
          {i18n.t('company_settings.general.factorial_referral_program.revamp.footer.title')}
        </Text>{' '}
        <Text size={'300'} color="black">
          {i18n.t('company_settings.general.factorial_referral_program.revamp.footer.subtitle')}
        </Text>
      </Box>
      <Box style={{ display: 'inline-block' }}>
        <F0Button
          icon={ExternalLink}
          variant="outline"
          onClick={handleTermsAndConditions}
          label={i18n.t('company_settings.general.factorial_referral_program.revamp.footer.button')}
        />
      </Box>
    </Box>
  )
}

export default FooterConditions
